import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getId, getToken, usePermissions } from "../../user/User"
import BasicTableComponent, { NumberRangeColumnFilter } from "../../components/basic.table"
import { toast } from "react-toastify"

const StatusList = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.status !== undefined && !permissions.status) {
            toast.error("You don't have permission to view statuses!")
            navigate("/")
        }
    }, [permissions])

    const columns =  [{
        Header: "Edit",
        UrlPart: "status"
    }, {
        Header: "Id",
        accessor: "id",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Name",
        accessor: "name"
    }, {
        Header: "Remind time in days",
        accessor: "remind_time_in_days",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }]

    const [statuses, setStatuses] = useState([])

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "/api/status", {
            headers: {
                "Authorization": "Bearer " + getToken()
            }
        })
        .then(res => {
            if(res.data === null || res.data === "") {
                return
            }
            setStatuses(res.data)
        }).catch(_ => {
            toast.error("Unable to load statuses!")
        })
    }, [])

    return (
        <div>
            <BasicTableComponent columns={columns} data={statuses} />
        </div>
    )
}

export default StatusList
